import React from "react";
import "./Footer.css";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaChevronRight,
} from "react-icons/fa";
import { FaLocationCrosshairs, FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ================= ABOUT ================= */}
        <div className="footer-col">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          <p className="footer-about">
            SPARSH CARGO PRIVATE LIMITED was founded in 2009 by a team of
            professionals with extensive experience in India’s express and
            logistics industry. 
          </p>
        </div>

        {/* ================= SERVICES ================= */}
        <div className="footer-col">
          <h4>Our Service</h4>
          <ul className="footer-links-list">
            <li><FaChevronRight /> Cash On Delivery</li>
            <li><FaChevronRight /> One Ship / Ware Housing</li>
            <li><FaChevronRight /> Prepaid Delivery</li>
            <li><FaChevronRight /> Reverse Pickup</li>
            <li><FaChevronRight /> Same Day Delivery</li>
          </ul>
        </div>

        {/* ================= COMPANY ================= */}
        <div className="footer-col">
          <h4>Our Company</h4>
          <ul className="footer-links-list">
            <li><FaChevronRight /><Link to="/">Home</Link></li>
            <li><FaChevronRight /><Link to="/about">About Us</Link></li>
            <li><FaChevronRight /><Link to="/tracking">Tracking</Link></li>
            <li><FaChevronRight /><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* ================= CONTACT ================= */}
        <div className="footer-col">
          <h4>Stay in touch</h4>

          <div className="contact-item">
            <FaEnvelope />
            <span>SPARSH.CARGO.PLTD@GMAIL.COM</span>
          </div>

          <div className="contact-item">
            <FaLocationCrosshairs />
            <span>
              GROUND FLOOR OF PROP NO E-84 PUL PEHLADPUR,
              NEW DELHI, India - 110044
            </span>
          </div>

          <div className="contact-item">
            <FaPhoneAlt />
            <span>9911176906</span>
          </div>

          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaXTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaInstagram /></a>
          </div>
        </div>

      </div>

      {/* ================= FOOTER BOTTOM ================= */}
      <div className="footer-bottom">
        <p>© 2025,  SPARSH CARGO PRIVATE LIMITED. All Rights Reserved</p>

        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
